<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Content from '@/services/Content'
    import Swal from "sweetalert2";
    import modalAddBusinessEvent from "@/components/modals/business/modalAddBusinessEvent";
    import modalEditBusinessEvent from "@/components/modals/business/modalEditBusinessEvent";
    import modalViewEventInfo from "@/components/modals/business/modalViewEventInfo";
    import modalViewBusinessEventMobilePreview from "@/components/modals/business/modalViewBusinessEventMobilePreview";
    import moment from "moment";



    export default {
        components: { Layout, PageHeader, modalAddBusinessEvent,modalEditBusinessEvent,modalViewEventInfo,modalViewBusinessEventMobilePreview},
        page: {
            title: "Business Events",
            meta: [
                {
                    name: "description",
                    content: appConfig.description,
                },
            ],
        },
        data() {
            return {
                title: "Events Business",
                items: [
                    {
                        text: "News",
                    },
                    {
                        text: "Events Business",
                        active: true,
                        href: "/news/feed",
                    },
                ],
                showRefresh:true,
                showAlert: false,
                isBusyButton: false,
                isBusy: false,
                error: null,
                showModal:false,
                modalData:{},
                link_id:null,
                tableData: [],
                totalRows: 0,
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 25, 50, 100],
                filter: null,
                filterOn: [],
                sortBy: "published",
                sortDesc: true,
                originalTableData: [],
                active: true,
                eventStatus: true,
                fields: [
                    {
                        key: "title",
                        label: "Event Name",
                        sortable: true,
                    },
                    {
                        key: "image",
                        label: "Image",
                        sortable: false,
                    },
                    {
                        key: "start_at",
                        label: "Date & Time",
                        sortable: true,
                    },
                    {
                        key: "location",
                        label: "Location",
                        sortable: true,
                    },
                    {
                        key: "userLimit",
                        label: "Subscribers 0/max",
                        sortable: true,
                    },
                    {
                        key: "companyLimit",
                        label: "Company Limit",
                        sortable: true,
                    },
                    {
                        key: "registrationLimit",
                        label: "Reservations/Event Limit",
                        sortable: false,
                    },
                    {
                        key: "toc",
                        label: "Terms and Conditions",
                        sortable: true,
                    },
                    
                    {
                        key: "active",
                        label: "Status",
                        sortable: true,
                    },
                    "action",
                ],
                 "refreshNewsBtn":false
            };
        },
        async created() {
            await this.getEvents()
            this.refreshNewsBtn = await this.checkObjectAccessCall('button.news.refresh');
        },
        methods: {
          parseLocalDateTime(value) {
            if (!value) return null;

            const str = String(value).trim();

            const m = moment(str, ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm', 'YYYY-MM-DD']);

            if (m.isValid()) {
              return m.toDate(); // Врати JavaScript Date објект
            }

            // Fallback на постари методи ако moment не успее
            let dt = new Date(str.replace(' ', 'T'));
            if (!isNaN(dt.getTime())) return dt;

            dt = new Date(str);
            return isNaN(dt.getTime()) ? null : dt;
          },
            isStartAtExpired(startAt) {
                const dt = this.parseLocalDateTime(startAt);
                if (!dt) return false;
                return dt.getTime() < Date.now();
            },

          getReservedSeats(item) {
            if (!item?.event_info?.members) return 0;

            return item.event_info.members.reduce((total, member) => {
              const reservation = parseInt(member?.reservation, 10);
              return total + (isNaN(reservation) ? 0 : reservation);
            }, 0);
          },

            getReservationsDisplay(item) {
              const reserved = this.getReservedSeats(item);
              const limit = (item && item.registrationLimit != null) ? item.registrationLimit : 0;
                return reserved + '/' + limit;
            },
            modalAddBusinessEvent() {
                this.$bvModal.show("add_business_event");
            },
            callModalBusinessEventEdit(data) {
                this.$bvModal.show("event_edit");
                this.modalData = data;
            },
            callModalViewEventInfo(data) {
                this.$bvModal.show("view_event_info");
                this.modalData = data;
            },
            callModalBusinessEventMobilePreview(data) {
                this.$bvModal.show("view_business_event_mobile_preview");
                this.modalData = data;
            },

            async getEvents(){
                try {
                    let eventStatus = this.eventStatus == true ? 'future' : 'all'
                    this.toggleBusy();
                    const response = await Content.getBusinessNews(1000,'all','event', eventStatus)
                    this.originalTableData = response.data.news
                    this.applyFilters(this.originalTableData)
                    this.totalRows = this.tableData.length
                    this.toggleBusy();
                } catch (error) {
                    this.toggleBusy();
                    this.error = error.response.data.error ? error.response.data.error : "";
                    this.tableData = []
                    this.totalRows = 0;
                }
            },

            applyFilters() {
                let filtered = [];

                if (this.active === true) {
                    // only active events
                    filtered = this.originalTableData.filter(item => item.active === 1);
                } else if (this.active === false) {
                    // only inactive events
                    filtered = this.originalTableData.filter(item => item.active === 0);
                } else {
                    // fallback: show all
                    filtered = this.originalTableData;
                }

                // map event_info only on filtered list
                this.tableData = filtered.map(newsItem => ({
                    ...newsItem,
                    start_at: newsItem.event_info?.start_at,
                    userLimit: newsItem.event_info?.userLimit,
                    companyLimit: newsItem.event_info?.companyLimit,
                    registrationLimit: newsItem.event_info?.registrationLimit,
                    location: newsItem.event_info?.location,
                    toc: newsItem.event_info?.toc,
                }));

                this.totalRows = this.tableData.length;
            },

//             removeEvent(id) {
//     Swal.fire({
//         title: "Remove event business?",
//         text: "This event business will be removed!",
//         icon: "warning",
//         showCancelButton: true,
//         confirmButtonColor: "#34c38f",
//         cancelButtonColor: "#f46a6a",
//         confirmButtonText: "Remove!",
//     }).then(async (result) => {
//         if (result.value) {
//             try {
//                 const response = await Content.deleteBusinessNews(id);
//                 if (response.data) {
//                     const newsItem = this.tableData.find((item) => item.id === id);
//                     if (newsItem) {
//                         newsItem.active = 0;
//                     }
//                     Swal.fire("Remove Business Event", "Business Event is successfully removed!", "success");
//                 } else {
//                     const error = response.data.error || "Failed";
//                     Swal.fire("Fail!", error, "warning");
//                 }
//             } catch (error) {
//                 this.error = error.response?.data?.error || "An error occurred";
//                 Swal.fire("Error", this.error, "error");
//             }
//         }
//     });
// },

            /**
             * Search the table data with search input
             */
            onFiltered(filteredItems) {
                // Trigger pagination to update the number of buttons/pages due to filtering
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },
            toggleBusy() {
                this.isBusy = !this.isBusy;
            },

        },
        middleware: "authentication",
    };
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                       <div class="row mb-0">
                            <div  class="col-12">
                                <a href="javascript:void(0);" :disabled=isBusyButton class="btn btn-success waves-effect waves-light text-end" @click="modalAddBusinessEvent()">
                                    <span v-if="!isBusyButton"><i class="mdi mdi-plus me-2"></i>Add Event</span>
                                    <span v-else>Loading...</span>
                                </a>
                            </div>
                        </div>
                        <h4 class="card-title">Total Events: {{totalRows}}</h4>
                        <div class="row mt-4">
                            <div class="col-sm-12 col-md-3">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Show&nbsp;
                                        <b-form-select
                                                v-model="perPage"
                                                size="sm"
                                                :options="pageOptions"
                                        ></b-form-select
                                        >&nbsp;entries
                                    </label>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="d-flex align-items-center">
                                    <label class="me-3 mb-0" for="eventsStatus">Inactive Events</label>

                                    <div class="form-check form-switch form-switch-lg mb-0">
                                        <input v-model="active"
                                               @change="applyFilters"
                                               type="checkbox"
                                               class="form-check-input"
                                               id="eventsStatus" />
                                    </div>
                                    <label class="mb-0" for="eventsStatus">Active Events</label>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="d-flex align-items-center">
                                    <label class="me-3 mb-0" for="eventsDateStatus">All Events</label>

                                    <div class="form-check form-switch form-switch-lg mb-0">
                                        <input v-model="eventStatus"
                                               @change="getEvents"
                                               type="checkbox"
                                               class="form-check-input"
                                               id="eventsDateStatus" />
                                    </div>
                                    <label class="mb-0" for="eventsDateStatus">Future Events</label>
                                </div>
                            </div>

                            <!-- Search -->
                            <div class="col-sm-12 col-md-3">
                                <div
                                        id="tickets-table_filter"
                                        class="dataTables_filter text-md-end"
                                >
                                    <label class="d-inline-flex align-items-center">
                                        Search:
                                        <b-form-input
                                                v-model="filter"
                                                type="search"
                                                placeholder="Search..."
                                                class="form-control form-control-sm ms-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <!-- Table -->
                        <div class="table-responsive mb-0">
                            <b-table
                                    :busy="isBusy"
                                    :items="tableData"
                                    :fields="fields"
                                    responsive="sm"
                                    :per-page="perPage"
                                    :current-page="currentPage"
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    :filter="filter"
                                    :filter-included-fields="filterOn"
                                    show-empty
                                    empty-text="No Data Found"
                                    @filtered="onFiltered"
                            >

                                <template v-slot:cell(image)="data">
                                    <div class="flex-shrink-0">
                                        <img class="img-fluid table-images" :src="data.item.image">
                                    </div>
                                </template>
                                <template v-slot:cell(start_at)="data">
        {{ data.item.start_at }}
    </template>
    <template v-slot:cell(userLimit)="data">
        {{ data.item.userLimit }}
    </template>
    <template v-slot:cell(registrationLimit)="data">
        {{ getReservationsDisplay(data.item) }}
    </template>
<template v-slot:cell(active)="data">
  <span :class="isStartAtExpired(data.item.start_at) ? 'text-danger' : (data.item.active === 1 ? 'text-success' : 'text-danger')">
    {{ isStartAtExpired(data.item.start_at) ? 'Expired' : (data.item.active === 1 ? 'Active' : 'Inactive') }}
  </span>
</template>
<template v-slot:cell(action)="data">
  <ul class="list-inline mb-0 d-flex">
<!--    <li class="list-inline-item" v-if="data.item.active === 1">-->
<!--      <a-->
<!--        href="javascript:void(0);"-->
<!--        class="px-2 text-danger"-->
<!--        v-b-tooltip.hover-->
<!--        title="Remove Business News"-->
<!--        @click="removeEvent(data.item.id)"-->
<!--      >-->
<!--        <i class="uil uil-trash-alt font-size-18"></i>-->
<!--      </a>-->
<!--    </li>-->
    <li class="list-inline-item">
        <a
          href="javascript:void(0);"
          @click="callModalViewEventInfo(data.item)"
          class="px-2 text-primary"
          title="View Subscribers List"
        >
          <i class="uil uil-users-alt font-size-18"></i>
        </a>
      </li>
      <li class="list-inline-item">
        <a
          href="javascript:void(0);"
          @click="callModalBusinessEventMobilePreview(data.item)"
          class="px-2 text-primary"
          title="Open Mobile Preview"
        >
          <i class="uil uil-mobile-android font-size-18"></i>
        </a>
      </li>
      <li class="list-inline-item">
        <a
          href="javascript:void(0);"
          class="px-2 text-primary"
          title="Edit Business News"
          @click="callModalBusinessEventEdit(data.item)"
        >
          <i class="uil uil-pen font-size-18"></i>
        </a>
      </li>
  </ul>
</template>
 <template #table-busy>
                <div class="text-center text-danger my-2">
                     <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                    </div>
                                </template>

                            </b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-end">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination
                                                v-model="currentPage"
                                                :total-rows="totalRows"
                                                :per-page="perPage"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

   <!-- MODALS -->
      <modalAddBusinessEvent  @refreshScreen="getEvents"></modalAddBusinessEvent>
      <modalEditBusinessEvent :data="modalData"  @onRefresh="getEvents"></modalEditBusinessEvent>
      <modalViewEventInfo :data="modalData"></modalViewEventInfo>
      <modalViewBusinessEventMobilePreview :data="modalData"></modalViewBusinessEventMobilePreview>
      <!-- END  MODALS -->
    </Layout>
</template>